// removed by extract-text-webpack-plugin
module.exports = {"container":"_3XfxL3rU90D2_LPJ8WjCS_","state":"_3lKBwkFYB8_zscVohOH8Vs"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/SendToSign/OwnerView/Buttons/AdminButtons/styles.css
// module id = 2830
// module chunks = 0